import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideTransloco } from '@jsverse/transloco';
import { provideOktaAuth, withOktaConfig } from '@okta/okta-angular';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { apiErrorInterceptor } from './core/interceptors/api-error.interceptor';
import { oktaAuthInterceptor } from './core/interceptors/okta-auth.interceptor';
import { APP_CONFIG } from './core/config/app-config.token';
import { oktaAuth } from './core/config/okta.config';
import { environment } from '../environments/environment';
import { TranslocoHttpLoader } from './core/i18n/transloco-loader';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(
      withXhr(),
      withInterceptors([oktaAuthInterceptor, authInterceptor, apiErrorInterceptor]),
    ),
    provideOktaAuth(withOktaConfig({ oktaAuth })),
    { provide: APP_CONFIG, useValue: { apiUrl: environment.apiUrl } },
    provideTransloco({
      config: {
        availableLangs: ['en', 'ru'],
        defaultLang: 'ru',
        fallbackLang: 'en',
        reRenderOnLangChange: true,
        prodMode: environment.production,
      },
      loader: TranslocoHttpLoader,
    }),
  ],
};
